import {AnyAction} from 'redux';
import {SET_USER} from '../actionTypes';

export interface UserState {
  id: string;
  dialCountryCode: string;
  mobileNumber: string;
  streamToken: string;
  profile: {
    avatar: string;
    birthDate: string;
    firstName: string;
    lastName: string;
  };
}

const initialState: UserState = {
  id: '',
  dialCountryCode: '',
  mobileNumber: '',
  streamToken: '',
  profile: {
    avatar: '',
    birthDate: '',
    firstName: '',
    lastName: '',
  },
};

export default (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        ...(action.payload || {}),
      };
    default:
      return state;
  }
};
